import { Link } from 'react-router-dom';

const categories = [
  {
    label: '新闻资讯',
    desc: '最新动态实时更新',
    icon: 'ri-newspaper-line',
    to: '/news',
  },
  {
    label: '影视作品',
    desc: '电影电视剧全收录',
    icon: 'ri-movie-2-line',
    to: '/works',
  },
  {
    label: '个人资料',
    desc: '生平简介与大事记',
    icon: 'ri-user-star-line',
    to: '/profile',
  },
  {
    label: '专题合集',
    desc: '深度专题精选回顾',
    icon: 'ri-stack-line',
    to: '/specials',
  },
];

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5">
      {categories.map((item) => (
        <Link
          key={item.to}
          to={item.to}
          className="cursor-pointer group bg-background-50 border border-background-200 rounded-lg p-4 md:p-5 flex flex-col items-center text-center hover:border-primary-300 transition-colors"
        >
          <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 text-xl mb-3 group-hover:bg-primary-700 group-hover:text-background-50 transition-colors">
            <i className={item.icon}></i>
          </span>
          <span className="font-heading text-sm md:text-base font-semibold text-foreground-950">{item.label}</span>
          <span className="text-xs text-foreground-500 mt-1">{item.desc}</span>
        </Link>
      ))}
    </div>
  );
}